import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../../store/action/auth';
import { getAdminUser, updateUserByAdmin } from '../../../store/action/user';
import {Nav} from "react-bootstrap";
import AdminStock from "./Inventory";
import AdminUserAddress from "./Address";
import AdminUserOrders from "./Order";
import AdminUserProductList from "./ProductList";
import AdminUserPaymentInfo from "./Payment";
import AdminUserTransaction from "./Transaction"
import axios from "axios";
import {API} from "../../../config";
import { FormModalButton } from "../../../components/organisms"

const AdminUserDetail = (props) => {
    const { token } = isAuthenticated();
    const [ loading, setloading ] = useState(true);
    const [ user , setUser ] = useState({
        id:'',
        name:'',
        email:'',
        phone:'',
        balance:'',
        address:'',
        subscriptions:'',
        organizationId:'',
        organizationName:'',
        couriers:[]
    });
    const [ values , setValues ] = useState({
        status:'',
        dueDate:''
    });
    const [ tab , setTab ] = useState('orders');

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const { userId } = props.match.params;
            const resUs = await getAdminUser(userId, token);

            if (resUs.success) {
                const us = resUs.user;

                const courierDiscounts = us.courier_discounts.reduce((r,i) => {
                    r.push({
                        courierCode:i.courier_code,
                        serviceCode:i.service_code,
                        discountPercentage:i.discount_percentage
                    });
                    return r
                },[]);

                setUser({
                    ...user,
                    id: us.id,
                    name: us.name,
                    email: us.email,
                    phone: us.phone,
                    balance: us.balance,
                    address: us.address,
                    subscriptions: us.subscriptions,
                    organizationId: us.organization_id,
                    organizationName: us.organization_name,
                    paymentStatus: us.payment_status,
                    paymentDueDate: us.payment_due_date,
                    couriers: us.couriers,
                    courierDiscounts
                })
            } else {
                alert(resUs.error)
            }

        } catch (e) {
            console.log (e);
            alert(e.message)
        }
        setloading(false)
    };

    const onSaveProfile = async (value) => {
        const { userId } = props.match.params;
        const res = await updateUserByAdmin(token,userId,{
            type:'address',
            value:value
        })
        if (res.success) {
            alert("Alamat berhasil disimpan")
            window.location.reload()
        }
    }
    
    const onSubmit = async () => {
        try {
            const res = await axios.post(`${API}/v1/admin/users/${props.match.params.userId}/payments`, {
                status:values.status,
                due_date:values.dueDate
            }, {
                mode: 'cors',
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if(res.data.success) {
                alert("Berhasil disimpan");
                window.location.reload()
            } else {
                alert(res.data.message);
            }
        } catch (e) {
            console.log (e);
            alert(e.message)
        }
    };


    const handleChange = name => event => {
        setValues({ ...values, error: false, [name]: event.target.value });
    };

    const nav = () => {
        return (
            <Nav variant="tabs" className="px-4" defaultActiveKey="active">
                <Nav.Item className="col-2 px-0 text-center">
                    <Nav.Link eventKey="active" onSelect={() => setTab('orders')}>
                        ORDERS
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item className="col-2 px-0 text-center">
                    <Nav.Link eventKey="address" onSelect={() => setTab('address')}>
                        ADDRESS
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item className="col-2 px-0 text-center">
                    <Nav.Link eventKey="catalog" onSelect={() => setTab('catalog')}>
                        KATALOG
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item className="col-2 px-0 text-center">
                    <Nav.Link eventKey="inventory" onSelect={() => setTab('inventory')}>
                        INVENTORY
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item className="col-2 px-0 text-center">
                    <Nav.Link eventKey="payment" onSelect={() => setTab('payment')}>
                        PAYMENT
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item className="col-2 px-0 text-center">
                    <Nav.Link eventKey="transactions" onSelect={() => setTab('transactions')}>
                        TRANSAKSI 
                    </Nav.Link>
                </Nav.Item>
            </Nav>
        )
    };

    const content = () => {
        if (tab === 'inventory') {
            return <AdminStock
                user={user}
                token={token}
            />
        } else if (tab === 'orders') {
            return <AdminUserOrders
                user={user}
                token={token}
            />
        } else if (tab === 'address') {
            return <AdminUserAddress
                user={user}
                token={token}
            />
        } else if (tab === 'catalog') {
            return <AdminUserProductList
                user={user}
                token={token}
            />
        } else if (tab === 'payment') {
            return <AdminUserPaymentInfo
                user={user}
                token={token}
                values={values}
                loading={loading}
                handleChange={handleChange}
                onSubmit={onSubmit}
            />
        } else if (tab === 'transactions') {
            return <AdminUserTransaction
                user={user}
                token={token}
            />
        }
    };

    return (
        <div className="bg-white rounded shadow">
            <div className="p-4">
                <h5>User's Information</h5>
            </div>
            <div className="row px-4">
                <div className="col-6">
                    <p>Nama: <b>{user.name} </b><span className="badge badge-primary border-primary">{user.id}</span></p>
                    <p>Email: <b>{user.email} </b></p>
                    <div className="col row">
                        <p>Alamat: <b>{user.address} </b> </p>
                        <FormModalButton 
                            buttonText="Edit Alamat"
                            onButtonClick={value => onSaveProfile(value)}
                        />
                    </div>
                    
                </div>
                <div className="col-6">
                    <p>Telpon: <b>{user.phone || "Belum Ada"} </b></p>
                    <p>Organisasi: <b>{user.organizationName  || "Belum Ada" } {user.organizationId ? `(${user.organizationId})` : ""}</b></p>
                </div>
            </div>
            
            { nav() }
            { loading ? null : content() }
        </div>
    )
};


export default AdminUserDetail;
